export const data = {
     baseurl : 'https://api.hellocheck.in/',
    //  baseurl : 'http://localhost:8080/',
    // fronturl:window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
    fronturl:window.location.protocol + '//' + window.location.hostname
}
